module.exports = __webpack_public_path__ + "img/search.b6d11de5.svg";